export default __webpack_public_path__ + "img/system-integration-solutions.71c784c1.png";